module.exports = __webpack_public_path__ + "img/no-data.5c6a0885.svg";